export default {
    requested : 5,
    completed : 1,
    declined : 6
}



// WEBPACK FOOTER //
// ./src/constants/candidate-reference-statuses.js